import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Gamepad2 } from 'lucide-react';
import { Button } from './ui/Button';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Games',
    href: '#games'
  }, {
    name: 'Features',
    href: '#features'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }, {
    name: 'About',
    href: '#about'
  }];
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/80 backdrop-blur-md shadow-lg py-2' : 'bg-transparent py-4'}`} data-id="element-124">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-125">
        {/* Logo */}
        <a href="#" className="flex items-center gap-2 group" data-id="element-126">
          <div className="bg-gradient-to-br from-candy-pink to-candy-purple p-2 rounded-xl rotate-3 group-hover:rotate-12 transition-transform duration-300" data-id="element-127">
            <Gamepad2 className="text-white w-6 h-6" data-id="element-128" />
          </div>
          <span className="font-heading text-2xl md:text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-candy-pink via-candy-purple to-candy-teal" data-id="element-129">
            Prismgames
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8" data-id="element-130">
          {navLinks.map(link => <a key={link.name} href={link.href} className="font-heading font-semibold text-candy-dark hover:text-candy-pink transition-colors relative group" data-id="element-131">
              {link.name}
              <span className="absolute -bottom-1 left-0 w-0 h-1 bg-candy-yellow rounded-full transition-all group-hover:w-full" data-id="element-132" />
            </a>)}
          <Button size="sm" className="bg-gradient-to-r from-candy-pink to-candy-orange shadow-lg shadow-candy-pink/30" data-id="element-133">
            Start Playing
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden p-2 text-candy-dark" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-134">
          {isMobileMenuOpen ? <X data-id="element-135" /> : <Menu data-id="element-136" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-137">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-candy-lavender overflow-hidden" data-id="element-138">
            <div className="flex flex-col p-4 gap-4" data-id="element-139">
              {navLinks.map(link => <a key={link.name} href={link.href} className="font-heading font-bold text-lg text-candy-dark hover:text-candy-pink py-2 border-b border-candy-lavender/50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-140">
                  {link.name}
                </a>)}
              <Button fullWidth onClick={() => setIsMobileMenuOpen(false)} data-id="element-141">
                Start Playing
              </Button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.nav>;
}